// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZCmHw","colMin":"styles_colMin__h9Dbk"};